var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('p',{staticClass:"font14"},[_c('f7-link',{attrs:{"href":"https://www.loadstarsecurities.com/","external":"","target":"_blank"}},[_vm._v("ロードスター証券株式会社 金融商品取引業者 関東財務局長（金商）第3202号")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7501a37b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Container/subpagefooter.vue
// module id = null
// module chunks = 